import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import EntityIdentifier from '@/models/Shared/EntityIdentifier';
import PayeeType from "@/models/Accounts/Shared/Payees/PayeeType";
import AccountType from '@/models/Shared/AccountType';

export default class Payee extends BaseInstitutionEntity {
    accountId: string;
    accountIdentifier: EntityIdentifier;
    accountNumber: string = '';
    accountType: AccountType;
    addressLine1: string;
    addressLine2: string;
    city: string;
    country: string;
    county: string;
    createdAtUtc: Date;
    createdBy: string;
    iban: string = '';
    name: string = '';
    payeeType: PayeeType;
    postCode: string;
    reference: string;
    sortCode: string = '';
    state: string = "ACTIVE";
    updatedAtUtc: Date;
}